import { render, staticRenderFns } from "./BaseBlockForm.vue?vue&type=template&id=5efe2dfd&scoped=true&"
import script from "./BaseBlockForm.vue?vue&type=script&lang=js&"
export * from "./BaseBlockForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockForm.vue?vue&type=style&index=0&id=5efe2dfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe2dfd",
  null
  
)

export default component.exports